import React, { useState, useContext } from "react";
import ProductContext from "../pages/pagesCardapio/ProductContext";
import Layout from "../components/Layout";
import DarkButton from "../components/DarkButton";
import GreenButton from "../components/GreenButton";
import SearchContainer from "../components/SearchContainer";
import { useEffect } from "react";
import api from '../services/api';
import { 
  FaHistory, 
  FaSearch, 
  FaPlusCircle, 
  FaTrashAlt, 
  FaSync, 
  FaArrowRight,
  FaMinus,
  FaPlus,
  FaCheck,
  FaReceipt,
  FaShoppingBag,
  FaFilter
} from 'react-icons/fa';

const PedidoColaborador = () => {
  const { products, categories, loading } = useContext(ProductContext);
  const [quantities, setQuantities] = useState({});
  const [expandedDescriptions, setExpandedDescriptions] = useState({});
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [showOrderDetails, setShowOrderDetails] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("");
  
  // Função para detectar tamanho da tela
  const getScreenSize = () => {
    const width = window.innerWidth;
    if (width < 768) return 'mobile';
    if (width >= 768 && width < 1024) return 'tablet';
    return 'desktop';
  };

  const [screenSize, setScreenSize] = useState(getScreenSize());
  const [searchQuery, setSearchQuery] = useState("");
  const [manualItems, setManualItems] = useState([]);
  const [showManualForm, setShowManualForm] = useState(false);
  const [manualName, setManualName] = useState("");
  const [manualPrice, setManualPrice] = useState("");
  const [lanchoneteOpen, setLanchoneteOpen] = useState(true);
  const [lanchoneteMsg, setLanchoneteMsg] = useState('');
  const [cardapioAtivo, setCardapioAtivo] = useState(false);

  useEffect(() => {
    const handleResize = () => setScreenSize(getScreenSize());
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    api.get('/lanchonete').then(r => {
      if (r.data.success) {
        setLanchoneteOpen(r.data.data.isOpen);
        setLanchoneteMsg(r.data.data.mensagemFechado || '');
        setCardapioAtivo(r.data.data.cardapioAtivo !== false);
      }
    }).catch(() => {});
  }, []);

  const toggleDescription = (id) => {
    setExpandedDescriptions(prev => ({
      ...prev,
      [id]: !prev[id]
    }));
  };

  const updateQuantity = (id, delta) => {
    setQuantities((prev) => ({
      ...prev,
      [id]: Math.max(0, (prev[id] || 0) + delta),
    }));
  };

  const addManualItem = () => {
    if (manualName.trim() && !isNaN(manualPrice) && parseFloat(manualPrice) > 0) {
      setManualItems([
        ...manualItems,
        {
          id: Date.now().toString(),
          name: manualName,
          price: parseFloat(manualPrice),
          quantity: 1,
        },
      ]);
      setManualName("");
      setManualPrice("");
      setShowManualForm(false);
    }
  };

  const removeManualItem = (id) => {
    setManualItems(manualItems.filter((item) => item.id !== id));
  };

  const removeProductItem = (id) => {
    setQuantities(prev => {
      const newQuantities = {...prev};
      delete newQuantities[id];
      return newQuantities;
    });
  };

  const handleConfirmOrder = () => {
    // Aqui você pode adicionar a lógica para enviar o pedido
    //console.log("Pedido confirmado:", getAllOrderItems());
    setShowConfirmModal(false);
    // Limpar o pedido após confirmação
    setQuantities({});
    setManualItems([]);
  };

  // Obtém todos os itens do pedido (cardápio + manuais)
  const getAllOrderItems = () => {
    const productItems = Object.entries(quantities)
      .filter(([_, qty]) => qty > 0)
      .map(([id, qty]) => {
        const product = products.find(p => p._id === id);
        return {
          id,
          name: product?.name || 'Produto não encontrado',
          price: product?.price || 0,
          quantity: qty,
          isManual: false
        };
      });

    const manualItemsList = manualItems.map(item => ({
      ...item,
      isManual: true
    }));

    return [...productItems, ...manualItemsList];
  };

  const totalAmount = getAllOrderItems().reduce(
    (total, item) => total + (item.price * item.quantity), 
    0
  );

  // Filtra produtos baseado na busca e categoria selecionada
  const filteredProducts = products.filter((item) => {
    const nameMatch = item.name.toLowerCase().includes(searchQuery.toLowerCase());
    const categoryMatch = item.category.toLowerCase().includes(searchQuery.toLowerCase());
    const categoryFilter = selectedCategory ? item.category === selectedCategory : true;
    
    return (nameMatch || categoryMatch) && categoryFilter;
  });

  // Filtra categorias que têm produtos visíveis
  const visibleCategories = categories.filter((cat) => 
    filteredProducts.some((item) => item.category === cat.name)
  );

  const filteredCategories = visibleCategories.map((category) => ({
    ...category,
    items: filteredProducts.filter((item) => item.category === category.name),
  }));

  // Função para renderizar descrição com "ler mais"
  const renderDescription = (item) => {
    const description = item.description || '';
    const isExpanded = expandedDescriptions[item._id];
    const maxLength = 60;

    if (description.length <= maxLength || isExpanded) {
  if (!cardapioAtivo) {
    return (
      <Layout title="Totem de Autoatendimento">
        <div style={{ ...styles.container, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '60vh', padding: '20px' }}>
          <div style={{
            backgroundColor: '#fce4ec',
            border: '2px solid #c62828',
            borderRadius: '16px',
            padding: '60px 20px',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '12px',
            maxWidth: '400px',
            width: '100%'
          }}>
            <FaFilter size={48} color="#c62828" style={{ opacity: 0.6 }} />
            <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '20px', fontWeight: '700', color: '#c62828' }}>
              Cardápio indisponível
            </span>
            <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '14px', color: '#b71c1c' }}>
              O cardápio foi desativado temporariamente pela administração.
            </span>
          </div>
        </div>
      </Layout>
    );
  }

  return (
        <p style={styles.productDescription}>
          {description}
          {description.length > maxLength && (
            <button 
              onClick={() => toggleDescription(item._id)}
              style={styles.readMoreButton}
            >
              ler menos
            </button>
          )}
        </p>
      );
    }

    return (
      <p style={styles.productDescription}>
        {description.substring(0, maxLength)}...
        <button 
          onClick={() => toggleDescription(item._id)}
          style={styles.readMoreButton}
        >
          ler mais
        </button>
      </p>
    );
  };

  // Renderização da barra de filtros por categoria
const renderCategoryFilters = () => {
  if (categories.length === 0) return null;

  return (
    <div style={styles.categoryFiltersContainer}>
      <div style={styles.categoryFilters}>
        {categories.map((category) => (
          <button
            key={category._id}
            onClick={() => setSelectedCategory(
              selectedCategory === category.name ? "" : category.name
            )}
            style={{
              ...styles.categoryFilterButton,
              ...(selectedCategory === category.name ? styles.categoryFilterButtonActive : {})
            }}
          >
            {category.name}
          </button>
        ))}
      </div>
    </div>
  );
};
  // Renderização mobile em lista
  const renderMobileProductList = () => {
    return (
      <div style={styles.mobileProductList}>
        {loading ? (
          <div style={styles.loadingContainer}>
            <FaSync style={styles.loadingIcon} spin />
            <p>Carregando cardápio...</p>
          </div>
        ) : (
          filteredCategories.map((group) => (
            <div key={group._id} style={styles.categorySection}>
              <h3 style={styles.categoryTitle}>{group.name}</h3>
              <div style={styles.mobileProductsList}>
                {group.items.map((item) => (
                  <div key={item._id} style={styles.mobileProductItem}>
                    <div style={styles.mobileProductImageContainer}>
                      <img
                        src={
                          item.image
                            ? `https://cardapio.olympicbarbacena.com.br${item.image}`
                            : "https://cardapio.olympicbarbacena.com.br/uploads/1737063857910.png"
                        }
                        alt={item.name}
                        style={styles.mobileProductImage}
                      />
                    </div>
                    <div style={styles.mobileProductInfo}>
                      <h4 style={styles.mobileProductName}>{item.name}</h4>
                      {renderDescription(item)}
                      <div style={styles.mobileProductFooter}>
                        <span style={styles.mobileProductPrice}>R$ {item.price?.toFixed(2) || "—"}</span>
                        <div style={styles.mobileQuantityControl}>
                          <button
                            onClick={() => updateQuantity(item._id, -1)}
                            style={{
                              ...styles.mobileQuantityButton,
                              ...(lanchoneteOpen ? {} : styles.disabledQuantityButton)
                            }}
                            disabled={!lanchoneteOpen || !quantities[item._id]}
                          >
                            <FaMinus />
                          </button>
                          <span style={styles.mobileQuantityValue}>
                            {quantities[item._id] || 0}
                          </span>
                          <button
                            onClick={() => updateQuantity(item._id, 1)}
                            style={{
                              ...styles.mobileQuantityButton,
                              ...(lanchoneteOpen ? {} : styles.disabledQuantityButton)
                            }}
                            disabled={!lanchoneteOpen}
                          >
                            <FaPlus />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    );
  };

  // Renderização normal (tablet/desktop)
  const renderNormalProductGrid = () => {
    return (
      <div style={styles.productsColumn}>
        {loading ? (
          <div style={styles.loadingContainer}>
            <FaSync style={styles.loadingIcon} spin />
            <p>Carregando cardápio...</p>
          </div>
        ) : (
          filteredCategories.map((group) => (
            <div key={group._id} style={styles.categorySection}>
              <h3 style={styles.categoryTitle}>{group.name}</h3>
              <div style={{
                ...styles.productsGrid,
                ...styles[screenSize + 'Grid'],
              }}>
                {group.items.map((item) => (
                  <div key={item._id} style={styles.productCard}>
                    <div style={styles.productImageContainer}>
                      <img
                        src={
                          item.image
                            ? `https://cardapio.olympicbarbacena.com.br${item.image}`
                            : "https://cardapio.olympicbarbacena.com.br/uploads/1737063857910.png"
                        }
                        alt={item.name}
                        style={styles.productImage}
                      />
                      <div style={styles.quantityOverlay}>
                        <div style={styles.quantityControl}>
                          <button
                            onClick={() => updateQuantity(item._id, -1)}
                            style={{
                              ...styles.quantityButton,
                              ...(lanchoneteOpen ? {} : styles.disabledQuantityButton)
                            }}
                            disabled={!lanchoneteOpen || !quantities[item._id]}
                          >
                            <FaMinus />
                          </button>
                          <span style={styles.quantityValue}>{quantities[item._id] || 0}</span>
                          <button
                            onClick={() => updateQuantity(item._id, 1)}
                            style={{
                              ...styles.quantityButton,
                              ...(lanchoneteOpen ? {} : styles.disabledQuantityButton)
                            }}
                            disabled={!lanchoneteOpen}
                          >
                            <FaPlus />
                          </button>
                        </div>
                      </div>
                    </div>
                    <div style={styles.productInfo}>
                      <h4 style={styles.productName}>{item.name}</h4>
                      {renderDescription(item)}
                      <div style={styles.productFooter}>
                        <span style={styles.productPrice}>R$ {item.price?.toFixed(2) || "—"}</span>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ))
        )}
      </div>
    );
  };

  return (
    <Layout title="Totem de Autoatendimento">
      <div style={{
        ...styles.container,
        ...styles[screenSize + 'Container'],
      }}>
        {!lanchoneteOpen && (
          <div style={{
            backgroundColor: '#fff3e0',
            border: '1px solid #ff9800',
            borderRadius: '12px',
            padding: '16px 20px',
            marginBottom: '16px',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            gap: '4px'
          }}>
            <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '14px', fontWeight: '700', color: '#e65100' }}>
              No momento não é possível realizar pedidos via APP.
            </span>
            <span style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '13px', color: '#bf360c' }}>
              {lanchoneteMsg || 'Faça seu pedido diretamente no balcão.'}
            </span>
          </div>
        )}

        {/* Header com busca e botão de item manual */}
        <div style={styles.header}>
          <div style={styles.searchContainer}>
            <SearchContainer
              placeholder="Buscar item..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </div>
          
          <button
            onClick={() => setShowManualForm(!showManualForm)}
            style={{
              ...styles.manualItemButton,
              ...(lanchoneteOpen ? {} : styles.disabledButton)
            }}
            disabled={!lanchoneteOpen}
          >
            <FaPlusCircle style={styles.manualItemIcon} />
            Item Manual
          </button>
        </div>

        {/* Barra de filtros por categoria */}
        {renderCategoryFilters()}

        {/* Formulário de item manual */}
        {showManualForm && (
          <div style={styles.manualFormOverlay}>
            <div style={styles.manualForm}>
              <div style={styles.formHeader}>
                <h4 style={styles.formTitle}>Adicionar Item Manual</h4>
                <button 
                  onClick={() => setShowManualForm(false)}
                  style={styles.closeFormButton}
                >
                  ×
                </button>
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.inputLabel}>Nome do Item</label>
                <input
                  placeholder="Ex: Suco Natural"
                  value={manualName}
                  onChange={(e) => setManualName(e.target.value)}
                  style={styles.textInput}
                />
              </div>
              <div style={styles.inputGroup}>
                <label style={styles.inputLabel}>Preço (R$)</label>
                <input
                  type="number"
                  placeholder="0.00"
                  value={manualPrice}
                  onChange={(e) => setManualPrice(e.target.value)}
                  style={styles.textInput}
                />
              </div>
              <button 
                onClick={addManualItem} 
                style={{
                  ...styles.confirmButton,
                  ...(!manualName.trim() || isNaN(manualPrice) || parseFloat(manualPrice) <= 0 ? styles.disabledButton : {})
                }}
                disabled={!manualName.trim() || isNaN(manualPrice) || parseFloat(manualPrice) <= 0}
              >
                Adicionar Item
              </button>
            </div>
          </div>
        )}

        {/* Modal de confirmação do pedido */}
        {showConfirmModal && (
          <div style={styles.modalOverlay}>
            <div style={styles.modalContent}>
              <div style={styles.modalHeader}>
                <FaReceipt style={styles.modalIcon} />
                <h3 style={styles.modalTitle}>Confirmar Pedido</h3>
                <button 
                  onClick={() => setShowConfirmModal(false)}
                  style={styles.closeModalButton}
                >
                  ×
                </button>
              </div>
              
              <div style={styles.modalBody}>
                <h4 style={styles.orderSummaryTitle}>Resumo do Pedido</h4>
                <div style={styles.orderSummary}>
                  {getAllOrderItems().map((item, index) => (
                    <div key={index} style={styles.summaryItem}>
                      <div style={styles.summaryItemInfo}>
                        <span style={styles.summaryItemName}>{item.name}</span>
                        <div style={styles.summaryItemControls}>
                          <button 
                            onClick={() => item.isManual ? removeManualItem(item.id) : updateQuantity(item.id, -1)}
                            style={{
                              ...styles.summaryQuantityButton,
                              ...(item.quantity <= 1 ? styles.disabledQuantityButton : {})
                            }}
                            disabled={item.quantity <= 1 && !item.isManual}
                          >
                            <FaMinus />
                          </button>
                          <span style={styles.summaryItemQuantity}>x{item.quantity}</span>
                          <button 
                            onClick={() => item.isManual ? 
                              setManualItems(manualItems.map(i => i.id === item.id ? {...i, quantity: i.quantity + 1} : i)) : 
                              updateQuantity(item.id, 1)}
                            style={styles.summaryQuantityButton}
                          >
                            <FaPlus />
                          </button>
                        </div>
                      </div>
                      <div style={styles.summaryItemRight}>
                        <span style={styles.summaryItemPrice}>
                          R$ {(item.price * item.quantity).toFixed(2)}
                        </span>
                        <button
                          onClick={() => item.isManual ? removeManualItem(item.id) : removeProductItem(item.id)}
                          style={styles.summaryItemRemove}
                        >
                          <FaTrashAlt />
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
                
                <div style={styles.modalTotal}>
                  <span style={styles.modalTotalLabel}>TOTAL</span>
                  <span style={styles.modalTotalAmount}>R$ {totalAmount.toFixed(2)}</span>
                </div>
              </div>

              <div style={styles.modalActions}>
                <button 
                  onClick={() => setShowConfirmModal(false)}
                  style={styles.cancelOrderButton}
                >
                  Cancelar
                </button>
                <button 
                  onClick={handleConfirmOrder}
                  style={styles.confirmOrderButton}
                >
                  <FaCheck style={styles.confirmIcon} />
                  Confirmar Pedido
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Área principal com duas colunas: produtos e pedido */}
        <div style={{
          ...styles.mainContent,
          ...styles[screenSize + 'Content'],
        }}>
          {/* Coluna de produtos - Mobile em lista, outros em grid */}
          {screenSize === 'mobile' ? renderMobileProductList() : renderNormalProductGrid()}

          {/* Coluna do pedido - No mobile fica fixa na parte de baixo */}
          <div style={{
            ...styles.orderColumn,
            ...styles[screenSize + 'OrderColumn'],
          }}>
            <div style={styles.orderContainer}>
              <h3 style={styles.orderTitle}>Seu Pedido</h3>
              
              {screenSize !== 'mobile' && (
                <div style={styles.orderItemsScroll}>
                  {getAllOrderItems().length > 0 ? (
                    <div style={styles.orderItemsList}>
                      {getAllOrderItems().map((item) => (
                        <div key={item.id} style={styles.orderItem}>
                          <div style={styles.orderItemInfo}>
                            <span style={styles.orderItemName}>
                              {item.name}
                            </span>
                            <div style={styles.orderItemDetails}>
                              <span style={styles.orderItemQuantity}>
                                {item.quantity}x
                              </span>
                              <span style={styles.orderItemPrice}>
                                R$ {(item.price * item.quantity).toFixed(2)}
                              </span>
                            </div>
                          </div>
                          <button
                            onClick={() => item.isManual ? removeManualItem(item.id) : removeProductItem(item.id)}
                            style={styles.orderItemRemove}
                          >
                            <FaTrashAlt />
                          </button>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <p style={styles.emptyMessage}>Nenhum item adicionado ainda</p>
                  )}
                </div>
              )}

              {/* No mobile, mostra apenas total e botão */}
              <div style={screenSize === 'mobile' ? styles.mobileOrderFooter : styles.orderTotal}>
                <span style={styles.totalLabel}>TOTAL</span>
                <span style={styles.totalAmount}>R$ {totalAmount.toFixed(2)}</span>
              </div>

              <button
                onClick={() => setShowConfirmModal(true)}
                style={{
                  ...styles.checkoutButton,
                  ...(getAllOrderItems().length === 0 || !lanchoneteOpen ? styles.disabledCheckoutButton : {})
                }}
                disabled={!lanchoneteOpen || getAllOrderItems().length === 0}
              >
                {!lanchoneteOpen ? 'Lanchonete Fechada' : screenSize === 'mobile' ? 'Ver Pedido' : 'Enviar Pedido'}
                <FaArrowRight style={styles.checkoutIcon} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

const styles = {
  container: {
    fontFamily: 'Montserrat, sans-serif',
    minHeight: "100vh",
    boxSizing: "border-box",
    width: "100%",
    backgroundColor: "#f8f9fa",
  },
  mobileContainer: {
    maxWidth: "100%",
    paddingBottom: "180px", // Reduzido para o footer mobile mais compacto
  },
  tabletContainer: {
    maxWidth: "100%",
    padding: "20px",
  },
  desktopContainer: {
    maxWidth: "1400px",
    margin: "0 auto",
    padding: "20px",
  },
  header: {
    display: "flex",
    gap: "15px",
    alignItems: "center",
    marginBottom: "20px",
    flexWrap: "wrap",
    padding: "0 20px",
    paddingTop: "20px",
  },
  searchContainer: {
    flex: "1",
    minWidth: "250px",
  },
  manualItemButton: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    backgroundColor: "#3f51b5",
    color: "white",
    border: "none",
    padding: "12px 20px",
    borderRadius: "8px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "14px",
    whiteSpace: "nowrap",
  },
  manualItemIcon: {
    fontSize: "16px",
  },
  manualFormOverlay: {
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: "1000",
    padding: "20px",
  },
  manualForm: {
    backgroundColor: "#ffffff",
    padding: "25px",
    borderRadius: "12px",
    boxShadow: "0 5px 20px rgba(0,0,0,0.2)",
    width: "100%",
    maxWidth: "400px",
  },
  formHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  formTitle: {
    color: "#3f51b5",
    margin: "0",
    fontSize: "18px",
    fontWeight: "600",
  },
  closeFormButton: {
    backgroundColor: "transparent",
    border: "none",
    fontSize: "24px",
    cursor: "pointer",
    color: "#757575",
    padding: "0",
    lineHeight: "1",
  },
  inputGroup: {
    marginBottom: "20px",
  },
  inputLabel: {
    display: "block",
    marginBottom: "8px",
    fontSize: "14px",
    color: "#616161",
    fontWeight: "500",
  },
  textInput: {
    width: "100%",
    padding: "14px",
    borderRadius: "8px",
    border: "1px solid #e0e0e0",
    fontSize: "14px",
    transition: "all 0.3s ease",
  },
  confirmButton: {
    backgroundColor: "#4caf50",
    color: "#fff",
    border: "none",
    padding: "14px 20px",
    borderRadius: "8px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "14px",
    width: "100%",
    transition: "all 0.3s ease",
    fontFamily: "Montserrat, sans-serif",
  },
  disabledButton: {
    backgroundColor: "#cccccc",
    cursor: "not-allowed",
  },
  // Modal de confirmação
  modalOverlay: {
    position: "fixed",
    top: "0",
    left: "0",
    right: "0",
    bottom: "0",
    backgroundColor: "rgba(0,0,0,0.7)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: "2000",
    padding: "20px",
  },
  modalContent: {
    backgroundColor: "#ffffff",
    borderRadius: "16px",
    padding: "25px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
    width: "100%",
    maxWidth: "500px",
    maxHeight: "90vh",
    overflow: "auto",
  },
  modalHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
    position: "relative",
  },
  modalIcon: {
    fontSize: "24px",
    color: "#4caf50",
    marginRight: "10px",
  },
  modalTitle: {
    color: "#3f51b5",
    margin: "0",
    fontSize: "22px",
    fontWeight: "600",
  },
  closeModalButton: {
    position: "absolute",
    right: "0",
    top: "0",
    backgroundColor: "transparent",
    border: "none",
    fontSize: "28px",
    cursor: "pointer",
    color: "#757575",
    padding: "0",
    lineHeight: "1",
  },
  modalBody: {
    marginBottom: "25px",
  },
  orderSummaryTitle: {
    color: "#333",
    margin: "0 0 15px 0",
    fontSize: "18px",
    fontWeight: "600",
    textAlign: "center",
  },
  orderSummary: {
    maxHeight: "300px",
    overflow: "auto",
    marginBottom: "20px",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    padding: "10px",
  },
  summaryItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    borderBottom: "1px solid #f0f0f0",
  },
  summaryItemInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    flex: "1",
  },
  summaryItemName: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#333",
  },
  summaryItemControls: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  summaryQuantityButton: {
    backgroundColor: "#3f51b5",
    color: "white",
    border: "none",
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "bold",
    transition: "all 0.2s ease",
  },
  disabledQuantityButton: {
    backgroundColor: "#cccccc",
    cursor: "not-allowed",
  },
  summaryItemQuantity: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#333",
    minWidth: "30px",
    textAlign: "center",
  },
  summaryItemRight: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    gap: "8px",
  },
  summaryItemPrice: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#4caf50",
  },
  summaryItemRemove: {
    backgroundColor: "transparent",
    border: "none",
    color: "#f44336",
    cursor: "pointer",
    fontSize: "14px",
    padding: "4px",
  },
  modalTotal: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 0",
    borderTop: "2px solid #e0e0e0",
  },
  modalTotalLabel: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#333",
  },
  modalTotalAmount: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#4caf50",
  },
  modalActions: {
    display: "flex",
    gap: "15px",
  },
  cancelOrderButton: {
    backgroundColor: "#f5f5f5",
    color: "#757575",
    border: "none",
    padding: "14px 20px",
    borderRadius: "8px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "14px",
    flex: "1",
    transition: "all 0.3s ease",
  },
  confirmOrderButton: {
    backgroundColor: "#4caf50",
    color: "#fff",
    border: "none",
    padding: "14px 20px",
    borderRadius: "8px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "14px",
    flex: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    transition: "all 0.3s ease",
  },
  confirmIcon: {
    fontSize: "16px",
  },
  mainContent: {
    display: "grid",
    gap: "20px",
  },
  mobileContent: {
    gridTemplateColumns: "1fr",
    padding: "0 20px",
  },
  tabletContent: {
    gridTemplateColumns: "2fr 1fr",
    height: "calc(100vh - 120px)",
  },
  desktopContent: {
    gridTemplateColumns: "3fr 1fr",
    height: "calc(100vh - 120px)",
  },
  // Estilos para lista mobile
  mobileProductList: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    overflow: "auto",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  },
  mobileProductsList: {
    display: "flex",
    flexDirection: "column",
    gap: "0",
  },
  mobileProductItem: {
    display: "flex",
    padding: "15px",
    borderBottom: "1px solid #f0f0f0",
    gap: "15px",
    alignItems: "flex-start",
  },
  mobileProductImageContainer: {
    width: "80px",
    height: "80px",
    flexShrink: "0",
  },
  mobileProductImage: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "8px",
  },
  mobileProductInfo: {
    flex: "1",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  mobileProductName: {
    margin: "0",
    fontSize: "16px",
    fontWeight: "600",
    color: "#212121",
    lineHeight: "1.3",
  },
  mobileProductFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "auto",
  },
  mobileProductPrice: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#4caf50",
  },
  mobileQuantityControl: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
  },
  mobileQuantityButton: {
    backgroundColor: "#3f51b5",
    color: "white",
    border: "none",
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "bold",
    transition: "all 0.2s ease",
  },
  mobileQuantityValue: {
    minWidth: "30px",
    textAlign: "center",
    fontSize: "16px",
    fontWeight: "600",
    color: "#333",
  },
  productsColumn: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    padding: "20px",
    overflow: "auto",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
  },
  orderColumn: {
    backgroundColor: "rgb(254 255 226)",
    borderRadius: "12px",
    boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
    display: "flex",
    flexDirection: "column",
  },
  mobileOrderColumn: {
    position: "fixed",
    bottom: "0",
    left: "0",
    right: "0",
    height: "185px", // Mais compacto para mobile
    borderBottomLeftRadius: "0",
    borderBottomRightRadius: "0",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    zIndex: "1000",
    padding: "15px",
    backgroundColor: "rgb(254 255 226)",
    boxShadow: "0 -5px 20px rgba(0,0,0,0.15)",
    marginBottom: "19%",
  },
  tabletOrderColumn: {
    padding: "20px",
  },
  desktopOrderColumn: {
    padding: "20px",
  },
  loadingContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    padding: "40px 0",
    color: "#757575",
  },
  loadingIcon: {
    fontSize: "24px",
    marginBottom: "15px",
  },
  categorySection: {
    marginBottom: "30px",
  },
  categoryTitle: {
    color: "#3f51b5",
    margin: "20px 0 15px 0",
    fontSize: "20px",
    fontWeight: "600",
    paddingLeft: "15px",
  },
  productsGrid: {
    display: "grid",
    gap: "15px",
  },
  mobileGrid: {
    gridTemplateColumns: "repeat(2, 1fr)",
  },
  tabletGrid: {
    gridTemplateColumns: "repeat(3, 1fr)",
  },
  desktopGrid: {
    gridTemplateColumns: "repeat(4, 1fr)",
  },
  productCard: {
    backgroundColor: "#ffffff",
    borderRadius: "12px",
    overflow: "hidden",
    boxShadow: "0 3px 10px rgba(0,0,0,0.1)",
    transition: "all 0.3s ease",
    border: "1px solid #f0f0f0",
    display: "flex",
    flexDirection: "column",
    height: "100%",
  },
  productImageContainer: {
    position: "relative",
    width: "100%",
    paddingBottom: "100%",
    overflow: "hidden",
  },
  productImage: {
    position: "absolute",
    top: "0",
    left: "0",
    width: "100%",
    height: "100%",
    objectFit: "cover",
  },
  quantityOverlay: {
    position: "absolute",
    bottom: "10px",
    left: "50%",
    transform: "translateX(-50%)",
    backgroundColor: "rgba(255,255,255,0.9)",
    borderRadius: "20px",
    padding: "5px 10px",
    boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
  },
  quantityControl: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  quantityButton: {
    backgroundColor: "#3f51b5",
    color: "white",
    border: "none",
    width: "28px",
    height: "28px",
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "bold",
    transition: "all 0.2s ease",
  },
  quantityValue: {
    minWidth: "20px",
    textAlign: "center",
    fontSize: "14px",
    fontWeight: "600",
    color: "#333",
  },
  productInfo: {
    padding: "15px",
    flex: "1",
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    minHeight: "120px",
  },
  productName: {
    margin: "0",
    fontSize: "16px",
    fontWeight: "600",
    color: "#212121",
    lineHeight: "1.3",
    minHeight: "40px",
    display: "flex",
    alignItems: "center",
  },
  productDescription: {
    margin: "0",
    fontSize: "13px",
    color: "#757575",
    lineHeight: "1.4",
    flex: "1",
    minHeight: "40px",
  },
  readMoreButton: {
    backgroundColor: "transparent",
    border: "none",
    color: "#3f51b5",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "500",
    marginLeft: "5px",
    textDecoration: "underline",
  },
  productFooter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "auto",
  },
  productPrice: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#4caf50",
  },
  orderContainer: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    minHeight: "0",
  },
  orderTitle: {
    color: "#3f51b5",
    margin: "0 0 15px 0",
    fontSize: "20px",
    fontWeight: "600",
    textAlign: "center",
  },
  orderItemsScroll: {
    flex: "1",
    overflow: "auto",
    marginBottom: "15px",
    minHeight: "0",
  },
  orderItemsList: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  orderItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "12px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    border: "1px solid #e9ecef",
  },
  orderItemInfo: {
    flex: "1",
  },
  orderItemName: {
    fontSize: "14px",
    fontWeight: "500",
    color: "#212121",
    display: "block",
    marginBottom: "4px",
  },
  orderItemDetails: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
  },
  orderItemQuantity: {
    fontSize: "12px",
    color: "#757575",
    backgroundColor: "#e0e0e0",
    padding: "2px 8px",
    borderRadius: "10px",
    fontWeight: "500",
  },
  orderItemPrice: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#4caf50",
  },
  orderItemRemove: {
    backgroundColor: "transparent",
    border: "none",
    color: "#f44336",
    cursor: "pointer",
    fontSize: "14px",
    padding: "4px",
    marginLeft: "10px",
  },
  emptyMessage: {
    textAlign: "center",
    color: "#9e9e9e",
    fontSize: "14px",
    padding: "20px",
  },
  orderTotal: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "15px 0",
    borderTop: "2px solid #e0e0e0",
    marginBottom: "15px",
  },
  mobileOrderFooter: {
    display: "flex",
    gap: "12px",
    marginTop: "auto",
    marginBottom: "15px",
  },
  totalLabel: {
    fontSize: "18px",
    fontWeight: "600",
    color: "#333",
  },
  totalAmount: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#4caf50",
  },
  checkoutButton: {
    backgroundColor: "#4caf50",
    color: "#fff",
    border: "none",
    padding: "16px 20px",
    borderRadius: "12px",
    fontWeight: "600",
    cursor: "pointer",
    fontSize: "20px",
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    transition: "all 0.3s ease",
    fontFamily: "Montserrat, sans-serif",
  },
  disabledCheckoutButton: {
    backgroundColor: "#cccccc",
    cursor: "not-allowed",
  },
  checkoutIcon: {
    fontSize: "16px",
  },

    categoryFiltersContainer: {
    padding: "0 20px 15px 20px",
    borderBottom: "1px solid #e0e0e0",
    marginBottom: "20px",
        // Scrollbar personalizada para desktop/tablet
    scrollbarWidth: "thin",
    scrollbarColor: "#c1c1c1 transparent",

        // Scrollbar para Webkit (Chrome, Safari, Edge)
    "&::-webkit-scrollbar": {
      height: "6px",
    },
    "&::-webkit-scrollbar-track": {
      background: "transparent",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#c1c1c1",
      borderRadius: "3px",
    },
    "&::-webkit-scrollbar-thumb:hover": {
      background: "#a8a8a8",
    },

  },
  categoryFilters: {
    display: "flex",
    gap: "10px",
    overflowX: "auto",
    paddingBottom: "5px",
    msOverflowStyle: "none",
  },

  categoryFilterButton: {
    backgroundColor: "#f5f5f5",
    color: "#666",
    border: "none",
    padding: "10px 20px",
    borderRadius: "20px",
    fontWeight: "500",
    cursor: "pointer",
    fontSize: "14px",
    whiteSpace: "nowrap",
    flexShrink: "0",
    transition: "all 0.3s ease",
    minWidth: "fit-content",
  },
  categoryFilterButtonActive: {
    backgroundColor: "#3f51b5",
    color: "white",
  },
  filterIcon: {
    fontSize: "12px",
  },


};

export default PedidoColaborador;